export const missions = {
  B1:  { name: "Apollo 11", date: "1969", significance: "first humans on the Moon" },
  C1:  { name: "Apollo 8", date: "1968", significance: "first humans to orbit the Moon" },

  B2:  { name: "International Space Station (ISS)", date: "1998 onward", significance: "permanent orbital laboratory and long duration human spaceflight platform" },
  C2:  { name: "Hubble Space Telescope", date: "1990", significance: "flagship space observatory that transformed modern astronomy" },

  B3:  { name: "James Webb Space Telescope", date: "2021", significance: "next generation infrared flagship observatory" },
  C3:  { name: "Voyager 1", date: "1977", significance: "farthest operating spacecraft in history" },

  B4:  { name: "Voyager 2", date: "1977", significance: "only spacecraft to visit Uranus and Neptune" },
  C4:  { name: "Viking 1", date: "1975", significance: "first successful Mars lander" },

  B5:  { name: "Viking 2", date: "1975", significance: "second Mars lander and orbiter system" },
  C5:  { name: "Apollo 17", date: "1972", significance: "final Apollo Moon landing and highest science return" },

  B6:  { name: "Apollo 13", date: "1970", significance: "successful deep space crisis recovery mission" },
  C6:  { name: "Apollo 15", date: "1971", significance: "first lunar rover mission" },

  B7:  { name: "Apollo 12", date: "1969", significance: "precision Moon landing" },
  C7:  { name: "Apollo 16", date: "1972", significance: "lunar highlands exploration" },

  B8:  { name: "Apollo 14", date: "1971", significance: "return to flight after Apollo 13" },
  C8:  { name: "Apollo 10", date: "1969", significance: "dress rehearsal for Apollo 11" },

  B9:  { name: "Apollo 9", date: "1969", significance: "first crewed lunar module test" },
  C9:  { name: "Apollo 7", date: "1968", significance: "first crewed Apollo mission" },

  B10: { name: "Artemis I", date: "2022", significance: "first SLS and Orion Moon test flight" },
  C10: { name: "Explorer 1", date: "1958", significance: "first successful US satellite" },

  B11: { name: "Mercury Redstone 3 (Freedom 7)", date: "1961", significance: "first American in space" },
  C11: { name: "Mercury Atlas 6 (Friendship 7)", date: "1962", significance: "first American to orbit Earth" },

  B12: { name: "Gemini 4", date: "1965", significance: "first US spacewalk" },
  C12: { name: "Gemini 8", date: "1966", significance: "first docking in space" },

  B13: { name: "Gemini 6A and Gemini 7", date: "1965", significance: "first crewed rendezvous" },
  C13: { name: "Gemini 12", date: "1966", significance: "perfected EVA techniques for Apollo" },

  B14: { name: "Skylab", date: "1973", significance: "first US space station" },
  C14: { name: "Apollo Soyuz Test Project", date: "1975", significance: "first US Soviet docking mission" },

  B15: { name: "Space Shuttle STS 1", date: "1981", significance: "first reusable orbital spacecraft flight" },
  C15: { name: "Space Shuttle Program", date: "1981 to 2011", significance: "enabled ISS assembly and Hubble servicing" },

  B16: { name: "Landsat 1", date: "1972", significance: "began continuous Earth observation record" },
  C16: { name: "GPS Constellation", date: "1978 onward", significance: "global positioning and timing infrastructure" },

  B17: { name: "TIROS 1", date: "1960", significance: "first successful weather satellite" },
  C17: { name: "Terra", date: "1999", significance: "major climate and land observation satellite" },

  B18: { name: "Aqua", date: "2002", significance: "Earth water cycle monitoring mission" },
  C18: { name: "GRACE", date: "2002", significance: "mapped Earth's gravity and water redistribution" },

  B19: { name: "GRACE Follow On", date: "2018", significance: "continued global gravity monitoring" },
  C19: { name: "SRTM", date: "2000", significance: "produced near global elevation model" },

  B20: { name: "DSCOVR", date: "2015", significance: "solar wind and Earth imaging from L1" },
  C20: { name: "Aura", date: "2004", significance: "atmospheric chemistry and ozone monitoring" },

  B21: { name: "Chandra X ray Observatory", date: "1999", significance: "flagship high energy telescope" },
  C21: { name: "COBE", date: "1989", significance: "measured cosmic microwave background" },

  B22: { name: "WMAP", date: "2001", significance: "precision cosmology measurements" },
  C22: { name: "Spitzer Space Telescope", date: "2003", significance: "infrared astronomy workhorse" },

  B23: { name: "Kepler", date: "2009", significance: "revolutionized exoplanet discovery" },
  C23: { name: "TESS", date: "2018", significance: "all sky exoplanet survey" },

  B24: { name: "Fermi Gamma ray Space Telescope", date: "2008", significance: "high energy gamma ray discoveries" },
  C24: { name: "Swift", date: "2004", significance: "gamma ray burst detection mission" },

  B25: { name: "WISE", date: "2009", significance: "infrared all sky survey" },
  C25: { name: "IRAS", date: "1983", significance: "first infrared sky survey" },

  B26: { name: "Mariner 2", date: "1962", significance: "first successful planetary mission" },
  C26: { name: "Mariner 4", date: "1965", significance: "first close up images of Mars" },

  B27: { name: "Mariner 10", date: "1973", significance: "first Mercury flyby mission" },
  C27: { name: "Pioneer 10", date: "1972", significance: "first Jupiter flyby" },

  B28: { name: "Pioneer 11", date: "1973", significance: "first Saturn flyby" },
  C28: { name: "Galileo", date: "1989", significance: "Jupiter orbiter and atmospheric probe" },

  B29: { name: "Magellan", date: "1989", significance: "mapped Venus surface by radar" },
  C29: { name: "Cassini", date: "1997", significance: "Saturn system flagship mission" },

  B30: { name: "Juno", date: "2011", significance: "Jupiter polar orbiter mission" },
  C30: { name: "New Horizons", date: "2006", significance: "first Pluto flyby mission" },

  B31: { name: "Mars Global Surveyor", date: "1996", significance: "modern Mars mapping baseline" },
  C31: { name: "Mars Pathfinder and Sojourner", date: "1997", significance: "first Mars rover" },

  B32: { name: "Mars Odyssey", date: "2001", significance: "long running Mars orbiter" },
  C32: { name: "Mars Reconnaissance Orbiter", date: "2005", significance: "high resolution Mars imaging" },

  B33: { name: "Spirit (MER A)", date: "2004", significance: "long duration Mars rover" },
  C33: { name: "Opportunity (MER B)", date: "2004", significance: "record setting Mars rover" },

  B34: { name: "Phoenix Mars Lander", date: "2008", significance: "confirmed water ice on Mars" },
  C34: { name: "Curiosity (MSL)", date: "2012", significance: "evidence of ancient habitability on Mars" },

  B35: { name: "MAVEN", date: "2014", significance: "studied Mars atmospheric loss" },
  C35: { name: "InSight", date: "2018", significance: "Mars interior seismology mission" },

  B36: { name: "Perseverance", date: "2021", significance: "sample caching for Mars return mission" },
  C36: { name: "Ingenuity Mars Helicopter", date: "2021", significance: "first powered flight on another planet" },

  B37: { name: "OSIRIS REx", date: "2016", significance: "asteroid sample return mission" },
  C37: { name: "NEAR Shoemaker", date: "1996", significance: "first spacecraft to orbit and land on asteroid" },

  B38: { name: "Dawn", date: "2007", significance: "orbited Vesta and Ceres" },
  C38: { name: "Stardust", date: "1999", significance: "comet sample return mission" },

  B39: { name: "Deep Impact", date: "2005", significance: "comet impact experiment mission" },
  C39: { name: "DART", date: "2021", significance: "asteroid deflection demonstration mission" },

  B40: { name: "Ranger 7", date: "1964", significance: "first successful Ranger lunar imaging" },
  C40: { name: "Surveyor 1", date: "1966", significance: "first US soft lunar landing" },

  B41: { name: "Lunar Orbiter Program", date: "1966 to 1967", significance: "mapped Moon landing sites" },
  B42: { name: "Lunar Prospector", date: "1998", significance: "evidence of lunar polar hydrogen" },
  B43: { name: "Lunar Reconnaissance Orbiter", date: "2009", significance: "modern high resolution lunar mapping" },
  B44: { name: "LADEE", date: "2013", significance: "lunar exosphere science mission" },
  B45: { name: "Parker Solar Probe", date: "2018", significance: "closest ever mission to the Sun" },
  B46: { name: "Solar Dynamics Observatory", date: "2010", significance: "continuous solar monitoring mission" },
  B47: { name: "STEREO", date: "2006", significance: "stereoscopic solar imaging mission" },
  B48: { name: "ACE", date: "1997", significance: "solar wind monitoring at L1" },
  B49: { name: "SOHO", date: "1995", significance: "major solar observatory mission" },
  B50: { name: "Voyager Golden Record", date: "1977", significance: "interstellar message from Earth" },
  B51: { name: "Telstar 1", date: "1962", significance: "early active communications satellite" },
  B52: { name: "Syncom 3", date: "1964", significance: "geostationary communications milestone" },
  B53: { name: "Echo 1", date: "1960", significance: "passive communications relay experiment" },
  B54: { name: "TDRSS", date: "1983 onward", significance: "near continuous NASA communications network" },
  B55: { name: "Corona Reconnaissance Program", date: "1960 onward", significance: "early space based photo reconnaissance" },
  B56: { name: "Seasat", date: "1978", significance: "pioneered radar ocean observation from space" },
  B57: { name: "International Ultraviolet Explorer", date: "1978", significance: "long running UV astronomy observatory" },
  B58: { name: "NuSTAR", date: "2012", significance: "focusing high energy X ray telescope" },
  B59: { name: "LAGEOS", date: "1976", significance: "precise Earth laser ranging mission" },
  B60: { name: "Explorer 6", date: "1959", significance: "early Earth imaging satellite mission" },
};

export function getMissionByNode(nodeId) {
  return missions[nodeId] || null;
}
